export default "/images/26f71592197ccd87da4a0a5e027015a7.avif";